import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import styled, { keyframes } from "styled-components";

interface BackdropProps
{
    onClick?: () => void;
    zIndex?: number;
}

const FadeIn = keyframes`
     0% { opacity: 0; }
     100% { opacity: 1; }
`;

const BackdropWrap = styled.div<BackdropProps>`
    background-color: rgba(0,0,0,0.5);
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: ${props => (props.zIndex) ? props.zIndex : "100"};
    animation: ${FadeIn} .5s forwards;
`;

const Backdrop: React.FC<BackdropProps> = (props) =>
{
    const { onClick } = props;

    // TODO: Is there a better solution to prevent scrolling?
    useEffect(() =>
    {
        // When the modal is open...
        const wsy = window.scrollY;
        document.body.style.position = "fixed";
        document.body.style.top = `-${wsy}px`;
        document.getElementsByTagName("html")[0].style.scrollBehavior = "auto"; //avoid scroll smoothing
        return () =>
        {
            // When the modal is hidden...
            const dsy = document.body.style.top;
            document.body.style.position = "";
            document.body.style.top = "";
            window.scrollTo(0, parseInt(dsy || "0") * -1);
            document.getElementsByTagName("html")[0].style.scrollBehavior = ""; //scroll smoothing back
        };
    }, []);

    return ReactDOM.createPortal(
        <BackdropWrap onClick={onClick} {...props} />
        , document.body
    );
};

export default Backdrop;